import React from 'react';
import { ComponentStory, ComponentMeta } from '@storybook/react';

import { Typography } from './Typography';

import { themeDefault } from 'src/theme';

export default {
  title: 'Revamp/Typography',
  component: Typography,
  argTypes: {
    children: { control: 'text' },
  },
} as ComponentMeta<typeof Typography>;

const Template: ComponentStory<typeof Typography> = (args) => (
  <Typography {...args} />
);

export const Title = Template.bind({});
Title.args = {
  variant: 'title',
  align: 'center',
  children: 'What is your date of birth?',
  theme: { ...themeDefault },
};

export const Description = Template.bind({});
Description.args = {
  variant: 'description',
  align: 'center',
  children: 'For example: 31-12-1980',
  theme: { ...themeDefault },
};
